<template lang="pug">
  v-card
    v-card-title.primary--text.justify-center.grey.lighten-4
      .title FORFAITS
    v-card-text
      v-data-table(
        :headers="headers.map(it => { return {text: it, value: it, sortable: false}})"
        hide-actions
        :items="catalog"
      )
        template(slot="headers" slot-scope="props")
          th.title.text-xs-left.font-weight-bold(v-for="header in props.headers") {{ header.text }}
        template(slot="items" slot-scope="props")
          td.title {{ props.item.name }}
          td.title {{ props.item.price }}€ H.T./mois
</template>

<script>
export default {
  data() {
    return {
      headers: ['Abonnement', 'Tarif'],
    };
  },
  computed: {
    catalog() {
      const catalog = this.$store.state.consumption.consumption.offers_catalog;
      if (catalog) {
        catalog.sort((a, b) => a.price - b.price);
      }
      return catalog || [];
    },
  },
};
</script>
